const version:string = "2.1.28";
const versions:string[] = [
    `V${version}`,
    `v${version}`,
    `V.${version}`,
    `v.${version}`
];
export const company:string = "14ninstudio";
export default versions;